import { type IShiftDetailsFormValues } from '~/components/ShiftRequestRedesign/ShiftDetails/ShiftDetailsForm/useShiftDetailsForm';

export interface IAutoConfirmRequest {
  favorites: boolean;
  eligibleProfessionals: boolean;
}

/**
 * Resolves the auto-confirm selection the request will actually carry.
 *
 * `buildJobPayloads` prefers a day's override over the form-level value, so a single
 * overridden day is enough for the payload to ask for auto-confirm even when the
 * form-level toggles read off. Callers that need to reason about what was *sent*
 * (analytics, error attribution) must therefore look at the overrides too.
 */
export const resolveAutoConfirmRequest = (
  formValues: IShiftDetailsFormValues,
): IAutoConfirmRequest => {
  const overrides = Object.values(formValues.shiftOverrides ?? {});

  return {
    favorites: Boolean(
      formValues.autoConfirm?.favorites ||
        overrides.some((override) => override.autoConfirm?.favorites),
    ),
    eligibleProfessionals: Boolean(
      formValues.autoConfirm?.eligibleProfessionals ||
        overrides.some((override) => override.autoConfirm?.eligibleProfessionals),
    ),
  };
};

/** Whether the request asks for auto-confirm at all, on any day. */
export const hasAutoConfirmRequest = (formValues: IShiftDetailsFormValues): boolean => {
  const { favorites, eligibleProfessionals } = resolveAutoConfirmRequest(formValues);

  return favorites || eligibleProfessionals;
};
